 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		47: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"5b36373794b742bcf453","1":"912fa4a5b2fe9ed30b2a","2":"4fc7dca126b6f79fbc18","3":"9f158be02e1cad121df1","4":"7ab3ef447dc58ba20bf0","5":"6af4be277f337d02e934","6":"0eb9ae1f318df8d63675","7":"358de6f33b8e06ffd262","8":"7c43b201e97eb8a55d1c","9":"e7f6ed8362091589d38c","10":"25f31fe574cec1585fef","11":"44064abaf34fddd7d08a","12":"36a4d685d3897ca9bff1","13":"0d5f7577bb6cc2138334","14":"c58d2a03300045e5df35","15":"8823a1671eeedcfd122c","16":"260503371f9e380b7867","17":"91aaa795b6643ac8fb09","18":"8cd812cf6f6e32645a57","19":"b9fd15da7d99ac3e5f7f","20":"b699ecec1c2450f859dc","21":"436be274a7b0bd13e513","22":"8d280756afb00f1b9481","23":"8b0f4e868723cec0d9c4","24":"512b5d1ab8512cd52c07","25":"68cd1f8df0f14fbc00cc","26":"17fd5b7a08707eab4ee9","27":"81955372c5dc87566e78","28":"a0ca872cba844db26521","29":"a7dcaee25743d2ed68fe","30":"ddae0de0dcacc6965801","31":"90991c0e7bf4a0bcc4b8","32":"0cdac0e0ec0118b23a53","33":"b977f6511a0da05d4579","34":"a718d98e9f829738508b","35":"88c934c345636cea36c5","36":"1366746188b50f9fa6b7","37":"11e8a5dafd6b733a8825","38":"d3b3fb68d22aa9f5abca","39":"e2bf52485b401881219a","40":"6eb239aeb2026855cb1d","41":"f75aec280b315882f255","42":"0261b4bf840277428d5c","43":"29ff253927b4893c83e2","44":"c0f7f50936046d2b5f17","45":"9f0bd17aa3e932018c9c","46":"9dd6b22850e24cd095ca","48":"bb5a00f2955b2faee37e","49":"cbafc5b93e25f1d63260","50":"cfcad9f62ebb137ea247","51":"69f5037b7cd09c8b3e8a","52":"3de302fbcaf2dd2b7d9a","53":"bdec4c809c7aed7e87b1","54":"990937cfe456e63a0004"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"5b36373794b742bcf453","1":"912fa4a5b2fe9ed30b2a","2":"4fc7dca126b6f79fbc18","3":"9f158be02e1cad121df1","4":"7ab3ef447dc58ba20bf0","5":"6af4be277f337d02e934","6":"0eb9ae1f318df8d63675","7":"358de6f33b8e06ffd262","8":"7c43b201e97eb8a55d1c","9":"e7f6ed8362091589d38c","10":"25f31fe574cec1585fef","11":"44064abaf34fddd7d08a","12":"36a4d685d3897ca9bff1","13":"0d5f7577bb6cc2138334","14":"c58d2a03300045e5df35","15":"8823a1671eeedcfd122c","16":"260503371f9e380b7867","17":"91aaa795b6643ac8fb09","18":"8cd812cf6f6e32645a57","19":"b9fd15da7d99ac3e5f7f","20":"b699ecec1c2450f859dc","21":"436be274a7b0bd13e513","22":"8d280756afb00f1b9481","23":"8b0f4e868723cec0d9c4","24":"512b5d1ab8512cd52c07","25":"68cd1f8df0f14fbc00cc","26":"17fd5b7a08707eab4ee9","27":"81955372c5dc87566e78","28":"a0ca872cba844db26521","29":"a7dcaee25743d2ed68fe","30":"ddae0de0dcacc6965801","31":"90991c0e7bf4a0bcc4b8","32":"0cdac0e0ec0118b23a53","33":"b977f6511a0da05d4579","34":"a718d98e9f829738508b","35":"88c934c345636cea36c5","36":"1366746188b50f9fa6b7","37":"11e8a5dafd6b733a8825","38":"d3b3fb68d22aa9f5abca","39":"e2bf52485b401881219a","40":"6eb239aeb2026855cb1d","41":"f75aec280b315882f255","42":"0261b4bf840277428d5c","43":"29ff253927b4893c83e2","44":"c0f7f50936046d2b5f17","45":"9f0bd17aa3e932018c9c","46":"9dd6b22850e24cd095ca","48":"bb5a00f2955b2faee37e","49":"cbafc5b93e25f1d63260","50":"cfcad9f62ebb137ea247","51":"69f5037b7cd09c8b3e8a","52":"3de302fbcaf2dd2b7d9a","53":"bdec4c809c7aed7e87b1","54":"990937cfe456e63a0004"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2328);
